import { jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Box } from "@biome-design-system/ui/Box";
import { Typography } from "@biome-design-system/ui/Typography";
const WizardHeader = styled(Box, {
  name: "MuiFilterWizard",
  slot: "header"
})(() => ({}));
const Header = ({ header }) => /* @__PURE__ */ jsx(WizardHeader, { "data-testid": "filter-wizard-header", children: typeof header === "string" ? /* @__PURE__ */ jsx(
  Typography,
  {
    component: "h1",
    variant: "subtitle2",
    children: header
  }
) : header });
export {
  Header
};
